import styles from './DescriptionPara.module.scss';

interface DescriptionParaProps {
  content?: string;
}

const DescriptionPara = ({ content = '' }: DescriptionParaProps): React.JSX.Element => {
  return <pre className={styles.description}>{content}</pre>;
};

export default DescriptionPara;
